var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartOverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.427619 10.7581C0.04262 12.0821 -0.0989236 13.5145 0.0709287 14.9982C0.30306 17.0184 1.10703 18.8674 2.31298 20.3853C2.80555 21.0131 3.70011 21.1443 4.33988 20.6707C5.01363 20.1742 5.13819 19.2155 4.61731 18.5592C3.64349 17.3265 3.02636 15.8029 2.94143 14.1479C2.87915 12.9438 3.09996 11.7968 3.53592 10.7581C4.68525 8.00752 7.35759 6.06154 10.4885 6.01017V8.88064C10.4885 9.04043 10.681 9.12603 10.8169 9.02902L16.6825 4.68052C16.7787 4.61203 16.7787 4.46366 16.6825 4.38947L10.8113 0.0409731C10.681 -0.0560407 10.4829 0.0295597 10.4829 0.189347V3.06552C5.72135 3.12259 1.70717 6.35828 0.427619 10.7581ZM18.6983 13.8852C18.619 12.2302 18.0019 10.7008 17.0224 9.47389C16.5015 8.81762 16.6261 7.8589 17.2941 7.36242C17.9339 6.88876 18.8228 7.02002 19.3211 7.64775C20.527 9.16573 21.331 11.0147 21.5574 13.0349C21.7216 14.5186 21.5857 15.951 21.2008 17.2749C19.9269 21.6805 15.907 24.9162 11.1455 24.9676V27.8437C11.1455 28.0035 10.953 28.0891 10.8171 27.9921L4.95154 23.6436C4.85529 23.5751 4.85529 23.4268 4.95154 23.3526L10.8228 19.0041C10.953 18.9071 11.1512 18.9927 11.1512 19.1524V22.0229C14.2821 21.9773 16.9544 20.0256 18.1038 17.2749C18.5341 16.242 18.7605 15.095 18.6983 13.8852Z",
    fill: "#120078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartOverIcon);
export default __webpack_public_path__ + "static/media/startOverIcon.f81edce7cfcce7ad1077ea91dd377748.svg";
export { ForwardRef as ReactComponent };